function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentPaymentMethodFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.084 17.404v-6.937h20.762v3.152c-1.381-.375-2.986-.587-4.728-.587-5.168 0-9.135 1.85-9.57 4.372H4.085zm0-8.938h20.762v-4H4.084v4zM27.73 21.749c0 1.156-2.965 2.835-7.612 2.835-4.646 0-7.612-1.68-7.612-2.835v-.866c1.729 1.12 4.442 1.818 7.612 1.818s5.883-.698 7.612-1.818v.866zm0-3.883c0 1.156-2.965 2.835-7.612 2.835-2.734 0-4.881-.583-6.188-1.297-.915-.5-1.424-1.063-1.424-1.538 0-.147.049-.303.142-.462.64-1.094 3.415-2.372 7.47-2.372 1.883 0 3.483.277 4.728.683.838.272 1.514.6 2 .945.573.407.884.834.884 1.206zm0 7.766c0 1.156-2.965 2.835-7.612 2.835-4.646 0-7.612-1.68-7.612-2.835v-.867c1.729 1.12 4.442 1.819 7.612 1.819s5.883-.7 7.612-1.82v.868zm-.884-11.277V3.465a1 1 0 00-1-1H3.084a1 1 0 00-1 1v14.939a1 1 0 001 1h7.422v6.228c0 2.756 4.133 4.835 9.612 4.835 5.48 0 9.612-2.08 9.612-4.835v-7.766c0-1.412-1.09-2.644-2.884-3.511z",
    fill: props.color
  }));
}

export default SvgIconPaymentPaymentMethodFilled;